import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

import {computed} from "vue";

interface Emit {
  (event: 'select'): void;
}

interface Props {
  title: string;
  selected: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentMethodTile',
  props: {
    title: {},
    selected: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const tileClass = computed(() => {
  if (props.selected) {
    return 'text-green-800 bg-green-050 border-green-500';
  }
  return 'text-neutral2-500 bg-neutral2-050 border-transparent';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex-grow-1 basis-1 text-center cursor-pointer rounded-lg py-8 border", tileClass.value]),
    textContent: _toDisplayString(props.title),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('select')))
  }, null, 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})